export const i18n = {
    us: {
        super: 'SUPER',
        early_bird: 'EARLY BIRD',
        include: 'Includes: ',
        delivery: 'Est. Delivery: ',
        backers: '{BACKERS} BACKERS',
        left: '{left} Left',
        save: 'SAVE',
        buy_now: 'Buy Now',
        sold_out: 'Sold Out',
        countdown: 'Ends in ',
        countdown_d: 'Days',
        countdown_h: 'Hours',
        countdown_m: 'Minutes',
        countdown_s: 'Seconds',
        coming_soon: 'Coming soon',
    },
    jp: {
        super: '超',
        early_bird: '早期割引',
        include: '同梱物: ',
        delivery: '発送日（見込み）: ',
        backers: '{BACKERS} 購入者',
        left: '在庫{left}',
        save: '割引き',
        buy_now: '今すぐ購入',
        sold_out: '売切れ',
        countdown: '終了まで ',
        countdown_d: '日',
        countdown_h: '時間',
        countdown_m: '分',
        countdown_s: '秒',
    },
};
